/**
 * Converts the first string character to upper case.
 *
 * @param string The string to capitalize.
 * @returns {string} Outputs capitalized string.
 */

export default function capitalize(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
